/* eslint-disable prefer-destructuring, no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { thinkOverSounds } from '@/utils/sounds';
import { DEVICE } from '@/constants';
import { OS, getOs } from '@/utils/detectDevice';
import './style.less';

class ThinkOver extends React.Component {
  static propTypes = {
    finished: PropTypes.func,
    exercisesData: PropTypes.object,
    url: PropTypes.string,
    audioPlay: PropTypes.func,
    audioStop: PropTypes.func,
    soundsUrl: PropTypes.string,
  };

  constructor() {
    super();
    this.state = {
      thinkOverData: null,
      right: false,
      pic: '',
      audio: '',
      question: '',
      playing: false,
    };
  }

  componentDidMount() {
    const { exercisesData, url } = this.props;
    console.log('exercisesData', exercisesData);
    this.init(exercisesData, url);
    window.addEventListener('resize', this.resizeHandler);
  }

  componentWillReceiveProps(nextProps) {
    nextProps.url !== this.props.url && this.init(nextProps.exercisesData, nextProps.url);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  init = (exercisesData, url) => {
    const questionData = exercisesData.questions[0].question[1]
      && exercisesData.questions[0].question[1].answer.length === 3
      ? exercisesData.questions[0].question[1]._attr
      : exercisesData.questions[0].question[0]._attr;
    const answer = exercisesData.questions[0].question[1]
      && exercisesData.questions[0].question[1].answer.length === 3
      ? exercisesData.questions[0].question[1].answer
      : exercisesData.questions[0].question[0].answer;
    const Data = answer.map(item => ({
      txt: item._attr.text._value.replace(new RegExp('%3Cbr%20/%3E', 'g'), '\n'),
      val: item._attr.score._value,
      class: '',
    }));
    this.setState({
      thinkOverData: Data,
      question: questionData.text && questionData.text._value.replace(new RegExp('%3Cbr%20/%3E', 'g'), '\n'),
      pic: questionData.image && `${url}${questionData.image._value}`,
      audio: questionData.audio && `${url}QAA/${questionData.audio._value}.ogg`,
      right: false,
    }, () => {
      this.resizeHandler();
    });
  }

  resizeHandler = () => {
    this.changeHeight();
  }

  handleCheck=(e, i) => {
    const { thinkOverData } = this.state;
    const { soundsUrl } = this.props;
    e.preventDefault();
    if (!this.state.right) {
      thinkOverData.forEach((item, index) => {
        console.log(item);
        thinkOverData[index].class = '';
      });
      thinkOverData[i].class = (thinkOverData[i].val === 100) ? 'right' : 'wrong';
      thinkOverSounds.wrong.sort(() => Math.random() - 0.5);
      thinkOverData[i].val === 100
        ? this.setState({ right: true }, () => {
          this.props.audioPlay(`${soundsUrl}${thinkOverSounds.allRight}`, { type: 'exercise' });
          this.props.finished();
        })
        : this.props.audioPlay(`${soundsUrl}${thinkOverSounds.wrong[0]}`, { type: 'exercise' });
      OS.TYPE === DEVICE.PC && this.audioEnd();
    }
    this.setState({ thinkOverData });
  }

  handlePlay = () => {
    const { playing, audio } = this.state;
    !playing ? this.props.audioPlay(audio, { type: 'exercise' }) : this.props.audioStop();
  }

  audioPlay = () => this.setState({ playing: true });

  audioEnd = () => this.setState({ playing: false });

  changeHeight = () => {
    document.querySelectorAll('.option-li').forEach((item) => {
      const style = window.getComputedStyle(item);
      const optionLi = item;
      const lineHeight = parseInt(style.lineHeight.slice(0, -2), 10);
      const maxSize = OS.TYPE === DEVICE.MOBILE ? 'calc(100vw * 18 / 375)' : '18px';
      const minSize = OS.TYPE === DEVICE.MOBILE ? 'calc(100vw * 15 / 375)' : '15px';
      Math.round((item.clientHeight - 40) / lineHeight) >= 2
        ? (optionLi.style.fontSize = maxSize)
        : (optionLi.style.fontSize = minSize);
    });
  }

  render() {
    const {
      thinkOverData,
      pic,
      audio,
      question,
      playing,
      right,
    } = this.state;
    const optionWrapperPcHeight = pic ? '391px' : '498px';
    const optionWrapperMHeight = pic ? 'calc(100vh * 338 / 667)' : 'calc(100vh * 410 / 667)';
    const ulPcHeight = pic ? '375px' : '464px';
    return (
      <div className="think-over-container" id="thinkOver">
        <div className={`think-over-question ${pic ? 'pic' : ''}`} id="question">
          {audio && <div className={`think-over-play${playing ? ' playing' : ''}`} onClick={this.handlePlay} />}
          <div className={`think-over-text ${!audio && 'noplay'}`}>
            {question}
          </div>
          <div className="clear" />
        </div>
        <div style={{ width: '100%' }} className="think-over-pic-box">
          {pic
            ? (
              <div className={`think-over-pic${audio ? '' : ' no-audio'}`}>
                <img className="filter" src={pic} alt="" />
                <img className="cover" src={pic} alt="" />
              </div>
            )
            : null }
        </div>
        <div
          className={`think-over-option${pic ? ' pic' : ''}`}
          id="optionWrapper"
          style={{
            height: getOs() === DEVICE.MOBILE ? optionWrapperMHeight : optionWrapperPcHeight,
          }}
        >
          <div
            className="option-wrapper"
            style={{
              height: getOs() === DEVICE.MOBILE ? 'calc(100vw * 294 / 375)' : ulPcHeight,
            }}
          >
            <ul>
              {
                thinkOverData && thinkOverData.map((item, index) => (
                  <li
                    key={`${index + 1}`}
                    className={`option-li ${item.class}`}
                    data-val={item.val}
                    dangerouslySetInnerHTML={{ __html: item.txt }}
                    onClick={(e) => { !right && this.handleCheck(e, index); }}
                  />
                ))
              }
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default ThinkOver;
